<template>
  <!--<nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav>-->
  <router-view/>
</template>
<script>
export default{
  setup(){
    const fontPath = window.location.origin + "/wp-content/plugins/loggiaColors/assets/";
		const fontM = "url('"+fontPath+"Montserrat.ttf');";
    var newStyle = document.createElement('style');
      newStyle.appendChild(document.createTextNode("\
      @font-face {\
          font-family: 'Montserrat';\
          src: "+fontM+"\
      }\
      "));
      document.head.appendChild(newStyle);
    return{fontM}
  }
}
</script>
<style>

#app {
  font-family: Montserrat !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
